import React, { ReactNode } from 'react';
import Line from 'components/Line';

interface SummaryCardProps {
  title?: string;
  logo?: ReactNode;
}

type Props = React.FC<React.HTMLAttributes<HTMLDivElement> & SummaryCardProps>;

const SummaryCard: Props = ({ title, className, children, logo, ...props }) => {
  return (
    <div
      className={`flex w-full flex-col justify-end bg-gray-lighter p-32 
      ${className ? className : ''}`}
      {...props}
    >
      {logo && logo}

      {title && <h2 className="text-h2-display">{title}</h2>}

      <Line />

      <p className="text-sm sm:text-base">{children}</p>
    </div>
  );
};

export default SummaryCard;
